var render = function render(){var _vm=this,_c=_vm._self._c;return _c('menu-item-abs',{attrs:{"type":"beverage"}})
}
var staticRenderFns = []

export { render, staticRenderFns }